import React from "react";
import CustomButton from "shared/components/button/CustomButton";
import { usePostConfirmarConfiguracao } from "hooks/groupPay/usePostConfirmarConfiguracao";

interface ButtonConfirmarConfiguracaoProps {
  groupPayEmail: string;
  onConfirmacaoIniciada?: () => void;
  isTesting?: boolean;
}

const ButtonConfirmarConfiguracao: React.FC<ButtonConfirmarConfiguracaoProps> = ({
  groupPayEmail,
  onConfirmacaoIniciada,
  isTesting = false,
}) => {
  const { mutate: confirmarConfiguracao, isLoading } = usePostConfirmarConfiguracao({
    onSuccess: () => {
      // Status será atualizado automaticamente via polling
    },
  });

  const handleClick = () => {
    // Chama imediatamente para mostrar a mensagem de aguardando
    onConfirmacaoIniciada?.();
    // Depois chama a API
    confirmarConfiguracao(groupPayEmail);
  };

  const isDisabled = isLoading || isTesting;

  return (
    <CustomButton
      id="confirmar-configuracao-btn"
      label={isDisabled ? "Processando..." : "Confirmar configuração"}
      variant="primary"
      disabled={isDisabled}
      onClick={handleClick}
      type="button"
    />
  );
};

export default ButtonConfirmarConfiguracao;

